import { useTranslation } from 'react-i18next';

import { Grid, Panel } from '@valwin/facto/components';

import { usePharmacyId } from '~shared/routes';

import { FacebookCard } from './facebook';
import { InstagramCard } from './instagram';

export function IntegrationsPanel() {
  const { t } = useTranslation();
  const pharmacyId = usePharmacyId();

  return (
    <Panel title={t('pharmacyConfig externalConnections')}>
      <Grid templateColumns="repeat(auto-fit, minmax(250px, 1fr))" gap={4}>
        <FacebookCard pharmacyId={pharmacyId} />
        <InstagramCard pharmacyId={pharmacyId} />
      </Grid>
    </Panel>
  );
}
